import { render, staticRenderFns } from "./VatInfoSelector.vue?vue&type=template&id=2a06fd7d"
import script from "./VatInfoSelector.vue?vue&type=script&lang=ts"
export * from "./VatInfoSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports